module.exports = __webpack_public_path__ + "static/media/team.73abe20a.jpg";